import { Grid, Progress, useLayout } from '@approvalmax/ui/src/components';

export const Loading = () => {
    useLayout({ hasHeader: true, hasDrawer: true });

    return (
        <Grid justifyContent='center' height='100%' alignItems='center'>
            <Progress shape='circle' size='large' />
        </Grid>
    );
};
